/**
 * SxaDimensionSelectionTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import Toolbar from '@material-ui/core/Toolbar';

// Sxa Components
import SxaDimensionTargetTile from "./SxaDimensionTargetTile";

class SxaDimensionSelectionTile extends React.Component {
    constructor(props) {
        super(props);

        // Assign current A ref to state for refresh
        this.state = { ass: props.ass };

        // List of Dimension Target refs
        this.dims = [];
    }

    // Callback function used by child D targets to signal selection
    handleSelectionChange = (q) => {
        //console.log("D selection changed; new current Question = " + q.oid);

        // Force re-render
        // FIXME - do this once at root (landscape/portrait) level and propagate downward
        var currA = this.state.ass;
        currA.currentQuestion = q;
        currA.currentProcessAreaID = q.paId;
        currA.currentDimensionID = q.dId;

        this.setState( state => ({ ass : currA}) );

        // Check that the selection state of the PAs matches the new current Q
        // Not done here - will be done from handleQChange()

        // Signal the change to the selected PA (if any) as a new current Q
        this.props.handleQChange(q);
    };

    // Logic to ensure D target selection flags are correctly set
    // Broken out so can be called in response to nav Back/Next
    updateSelectionState = (q) => {
        // Get the mapped Ds for the current selected PA
        var currentPAName = q.paName;
        var allPAs = this.state.ass.processAreas;
        var palen = allPAs.length;
        var k = 0, nextPA;
        var currentPA = null;
        for (k; k < palen; k++) {
            nextPA = allPAs[k];
            if (nextPA.name === currentPAName) {
                currentPA = nextPA;
                break;
            }
        }
        //console.log("D-Target.updateSelectionState(): currentPA = " + currentPA.name);

        // Update the D target enabled flags to reflect the mapped Ds
        var mappedDs = currentPA.mappedDs;


        // Check that the selection state of the PAs matches the new current Q
        var currDName = q.dName;
        var i = 0, nextD, nextDName;
        var len = this.dims.length;
        for (i; i < len; i++) {
            nextD = this.dims[i];
            nextDName = nextD.state.dim.name;
            if (nextDName === currDName) {
                // Ensure D marked as selected TRUE
                //console.log("Next D matches current D, name = " + currDName);
                if (nextD.state.dim.selected !== true) {
                    //console.log("Marking D selected, name = " + nextDName);
                    nextD.updateSelection(true);
                }
            }
            else {
                // Ensure D marked as selected FALSE
                if (nextD.state.dim.selected === true) {
                    //console.log("Marking D de-selected, name = " + nextDName);
                    nextD.updateSelection(false);
                }
            }

            // Look for the D-target in the list of mapped Ds
            var m = 0, nextMD;
            var mdlen = mappedDs.length;
            var matched = false;
            for (m; m < mdlen; m++) {
                nextMD = mappedDs[m];
                if (nextMD.name === nextDName) {
                    matched = true;
                    break;
                }
            }
            // Set enabled flag based on mapped or not
            nextD.updateEnabled(matched);
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.ass.dimensions ? (
                    <Toolbar>
                        {this.state.ass.dimensions.map( (nextD, index) =>
                            <div key={nextD.oid}>
                            <SxaDimensionTargetTile dim={nextD}
                                                    handleSelectionChange={this.handleSelectionChange}
                                                    innerRef={(dim) => { this.dims[index] = (dim); }}
                            />
                            </div>
                        )}
                    </Toolbar>
                ) : "No Dimensions found"}
            </React.Fragment>
        )
    }
}

export default SxaDimensionSelectionTile;